import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
} from "@chakra-ui/react";
import { Button } from "@mui/material";
import * as React from "react";
export default function CustomAlertDialog({
  visible,
  description,
  secondary,
  primary,
  title,
  data,
}) {
  //console.log("alerting...");
  const [open, setOpen] = React.useState(visible);

  const cancelRef = React.useRef();
  const handleClose = () => {
    // setOpen(false);
    secondary?.onPress ? secondary?.onPress(data) : setOpen(false);
  };

  const handleProceed = () => {
    // setOpen(false);
    primary?.onPress ? primary?.onPress(data) : setOpen(false);
  };

  return (
    <>
      <AlertDialog
        isOpen={open}
        leastDestructiveRef={cancelRef}
        onClose={handleClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {title}
            </AlertDialogHeader>

            <AlertDialogBody>{description}</AlertDialogBody>

            <AlertDialogFooter>
              {secondary ? (
                <Button
                  ref={cancelRef}
                  className="can_btn"
                  onClick={handleClose}
                >
                  {secondary?.buttonTxt || "Cancel"}
                </Button>
              ) : null}
              <div className="ml-2" />
              <Button className="sav_btn" onClick={handleProceed}>
                {primary?.buttonTxt || "Proceed"}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}
